import qs from 'qs';

export function getLocale() {
  let lang = 'zh-CN';
  const { search } = window.location;
  const { userAgent } = window.navigator;

  if (BRAND === 'sensforge') {
    lang = 'en-US';
  }

  if (userAgent.toLocaleLowerCase().indexOf('en-us') > -1) {
    lang = 'en-US';
  }
  const query = qs.parse(search, { ignoreQueryPrefix: true });
  if (query.locale) {
    lang = query.locale as string;
  }

  return lang;
}

export const langCN = getLocale().toLocaleLowerCase() === 'zh-cn';
export const langEN = getLocale().toLocaleLowerCase() === 'en-us';
